var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center loading-spinner-overlay",class:{active:_vm.isVisible},attrs:{"id":"overlay"}},[_c('div',{staticClass:"backdrop"}),(_vm.isVisible)?_c('LoadingSpinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }